import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import TaxFilingProgressStepper from './TaxFilingProgressStepper';
import { api } from '../lib/api';
import { toast } from 'sonner';

/**
 * Member-facing wrapper: fetches years + timeline, exposes a year switcher,
 * wires CTA buttons (upload / sign / view tax file) into router navigations.
 */
export default function MemberTaxFilingProgressCard({ className = '', compact = false }) {  const nav = useNavigate();
  const [years, setYears] = useState([]);
  const [year, setYear] = useState(null);
  const [timeline, setTimeline] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const y = await api.myTaxFilingYears();
        setYears(y.years || []);
        setYear(y.default);
      } catch {
        // soft-fail
        setYears([]);
      }
    })();
  }, []);

  useEffect(() => {
    if (!year) return;
    let cancelled = false;
    setLoading(true);
    api.myTaxFilingTimeline(year).then((t) => {
      if (!cancelled) setTimeline(t);
    }).catch(() => {
      if (!cancelled) toast.error('Could not load progress timeline');
    }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [year]);

  const handleAction = (kind /* , stage */) => {
    if (kind === 'upload') nav('/account/documents/upload');
    else if (kind === 'sign') nav('/account/tax-file');
    else if (kind === 'view-tax-file') nav('/account/tax-file');
  };

  return (
    <div className={className}>
      {years.length > 1 && (
        <div className="mb-3 flex items-center justify-end">
          <label htmlFor="tracker-year" className="sr-only">Select tax year</label>
          <div className="relative">
            <select
              id="tracker-year"
              data-testid="tracker-year-select"
              value={year || ''}
              onChange={(e) => setYear(Number(e.target.value))}
              className="appearance-none pl-3 pr-9 py-2 rounded-md border border-neutral-200 bg-white text-[13px] font-semibold text-[#14110f] hover:border-neutral-300 focus:border-[#f5b300] focus:outline-none transition"
            >
              {years.map((y) => (
                <option key={y} value={y}>Tax year {y}</option>
              ))}
            </select>
            <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-neutral-400 pointer-events-none" />
          </div>
        </div>
      )}
      <TaxFilingProgressStepper
        timeline={timeline}
        loading={loading}
        onAction={handleAction}
      />
    </div>
  );
}
